(function () {
  'use strict';

  angular
    .module('unit.cancel.deal')
    .factory('UnitCancelDealService', UnitCancelDealService);

  UnitCancelDealService.$inject = ['$mdDialog'];

  function UnitCancelDealService(
    /** @type {angular.material.IDialogService} */ $mdDialog,
  ) {
    var service = {
      show: show,
    };
    return service;

    /*
     *   scope: {
     *        onCancel,
     *        onBack,
     *        dealId
     *    }
     */
    function show(scope) {
      $mdDialog.show({
        clickOutsideToClose: true,
        //targetEvent: event,
        parent: angular.element('body'),
        template: require('../unit.cancel.deal/unit.cancel.deal.html'),
        //preserveScope: true,
        controller: 'unitCancelDealCtrl',
        controllerAs: 'vm',
        locals: scope,
      });
    }
  }
})();
